<script>
import { h } from 'vue';
import $ from 'jquery';
import equal from 'deep-equal';
import { v4 as uuidv4 } from 'uuid';

if (!$().selectize) {
    require('./selectize');
}

export default {
    emits: ['input'],

    props: {
        value: { default: '' },
        settings: { type: Object, default: () => {} },
        placeholder: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
    },

    data() {
        return {
            current: null,
            uuidDropdownClass: `dropdown-${uuidv4()}`,
        };
    },

    computed: {
        options() {
            if (this.current !== null) {
                return this.current.map((option) => ({
                    text: option.text,
                    value: option.value,
                }));
            }

            return [];
        },
    },

    watch: {
        placeholder(value, old) {
            if (this.$el.selectize && !equal(value, old)) {
                this.$el.selectize.settings.placeholder = value;
                this.$el.selectize.updatePlaceholder();
            }
        },

        value() {
            this.setValue();
        },

        options(value, old) {
            if (this.$el.selectize && !equal(value, old)) {
                this.$el.selectize.clearOptions();
                this.$el.selectize.addOption(this.current);
                this.$el.selectize.refreshOptions(false);
                this.setValue();
            }
        },

        disabled(disabled) {
            if (disabled) {
                this.$el.selectize.disable();
            } else {
                this.$el.selectize.enable();
            }
        },
    },

    methods: {
        track(nodes) {
            if (nodes) {
                this.current = nodes
                    .filter((node) => node.tag && node.tag.toLowerCase() === 'option')
                    .map((node) => {
                        return {
                            text: node.children ? node.children[0].text.trim() : null,
                            value: node.data.domProps
                                ? node.data.domProps.value
                                : node.data.attrs.value,
                            ...node.data.attrs,
                        };
                    });
            } else {
                this.current = [];
            }
        },

        setValue() {
            this.$el.selectize.setValue(this.value);
        },

        removeDropdown() {
            if (this.settings.dropdownParent === 'body') {
                const dropdown = document.querySelector(`.${this.uuidDropdownClass}`);

                if (dropdown) {
                    dropdown.remove();
                }
            }
        },
    },

    mounted() {
        const _this = this;
        const dropdownId = this.$parent.$attrs.id;
        const dropdownClassSettings = this.settings.dropdownClass;
        const dropdownClass = dropdownClassSettings
            ? `${dropdownClassSettings} ${this.uuidDropdownClass}`
            : `selectize-dropdown ${this.uuidDropdownClass}`;

        $(this.$el).selectize({
            onInitialize: function () {
                _this.setValue();
            },
            onChange: function (value) {
                _this.$emit('input', value);
            },
            ...this.settings,
            dropdownClass: dropdownClass,
            dropdownId: dropdownId,
        });

        if (this.disabled) {
            this.$el.selectize.disable();
        }
    },

    beforeUnmount() {
        this.removeDropdown();
    },

    render(c) {
        const children = this.$slots.default();

        if (this.settings.options === undefined) {
            this.track(children);
        }

        return h('select', children);
    },
};
</script>
<style>
.manage-members__dropdown-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 14px 8px 10px;
}
.manage-members__dropdown-actions .clear-all-label__dropdown {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #4b4b4b;
}
.manage-members__dropdown-actions .clear-all-button__dropdown {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #4794ec;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: 5px;
    text-decoration: underline;
}
</style>
